import { InputText } from 'ui/inputs';
import { FormField } from 'ui/formField';

import {
  LargeInputWrapper,
  PlusHalfIndentedFormSectionContent,
} from 'modules/workflowNodeEditors/EditorBody.styled';
import { useState } from 'react';
import noop from 'utils/noop';
import { pluralizeWord } from 'modules/campaigns/lib/utils';
import { DEFAULT_ATTRIBUTION_PERIOD, MAX_ATTRIBUTION_PERIOD } from '../../BaseSendEditor.constants';
import { validateMultiAttributionPeriod as validate } from '../../BaseSendEditor.utils';

export interface MultiConversionPeriodInputProps {
  value?: number;
  onChange?: (period: number) => void;
  isDisabled?: boolean;
}

export default (props: MultiConversionPeriodInputProps) => {
  const { value: period, onChange = noop, isDisabled = false } = props;
  const [periodError, setPeriodError] = useState(validate(period as number));

  return (
    <PlusHalfIndentedFormSectionContent>
      <FormField
        errorText={periodError?.message}
        hasError={periodError?.hasError}
        inputId="attr-period-field"
      >
        <LargeInputWrapper id="attr-period-wrapper">
          <InputText
            hasError={periodError?.hasError}
            id="attr-period"
            // TODO: fix the getting of html number attrs in input text
            // @ts-ignore
            max={MAX_ATTRIBUTION_PERIOD}
            onBlur={() => setPeriodError(validate(period as number))}
            onChange={(periodString: string) => onChange(Number(periodString))}
            placeholder={period ? '' : `${DEFAULT_ATTRIBUTION_PERIOD}`}
            Suffix={
              <span>{`${pluralizeWord('hour', period)}\n (max: ${MAX_ATTRIBUTION_PERIOD})`}</span>
            }
            type="number"
            value={`${period}`}
            isDisabled={isDisabled}
          />
        </LargeInputWrapper>
      </FormField>
    </PlusHalfIndentedFormSectionContent>
  );
};
